import * as React from 'react';

import { IJkSchema } from '../../repositories/special-promos/entities/entities/JkSchema';
import { IFlatPriceInfoSchema } from '../../repositories/special-promos/entities/entities/FlatPriceInfoSchema';

import { formatFlatPrice } from '../../utils/formatters';
import { getFlatType } from '../../utils/rooms';
import { ellipsis } from '../../utils/text';

import * as styles from './index.css';
import classNames from 'classnames';

interface IJkListItemProps {
  jk: IJkSchema;
}

const MAX_LENGTH_PROMO_ACTION_LABEL = 35;

export class JkListItem extends React.Component<IJkListItemProps, object> {
  public render() {
    const { jk } = this.props;

    return (
      <a
        className={styles['jk']}
        href={jk.fullUrl ?? ''}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="JkListItem"
      >
        <div className={styles['image']} style={{ backgroundImage: `url(${jk.image?.url ?? ''})` }}>
          {jk.promoLabel && (
            <div className={styles['promo-label']}>{ellipsis(jk.promoLabel, MAX_LENGTH_PROMO_ACTION_LABEL)}</div>
          )}
          <div
            className={classNames(
              styles['status'],
              jk.isFinished ? styles['status-finished'] : '',
              'iefix_jk_list_item_status',
            )}
          >
            {jk.buildingStatusInfo}
          </div>
        </div>
        <div className={styles['info']}>
          <div className={styles['name']}>{jk.name}</div>
          <div className={styles['address']}>{jk.address}</div>
          <div className={styles['flat-list']}>{this.renderPrices(jk.flatInfoList ?? [])}</div>
        </div>
      </a>
    );
  }

  private renderPrices = (list: IFlatPriceInfoSchema[]) => {
    let flatInfoList = [...list];
    const lastIndex = flatInfoList.length - 1;
    const lastElement = flatInfoList[lastIndex];

    if (lastElement.flatType === 'studio') {
      flatInfoList = [lastElement, ...flatInfoList.slice(0, lastIndex)];
    }

    return flatInfoList.map((flatInfo, idx) => (
      <div className={styles['row']} key={idx}>
        <div className={styles['flat']}>{getFlatType(flatInfo.flatType)}</div>
        <div className={styles['divider']} />
        <div className={styles['price']}>{formatFlatPrice(flatInfo.minPrice ?? undefined)}</div>
      </div>
    ));
  };
}
